import React from "react";
import { Helmet } from "react-helmet";
import "./Impact.scss";
import vid from "../../assets/impactvid2.mp4";
import ImpactImages from "../../components/impactComponents/impactImages/ImpactImages.jsx";
import HomeVideo from "../../components/homeComponents/homeVideo/HomeVideo.jsx";
import ImpactAlumniImpact from "../../components/impactComponents/ImpactAlumniImpact/ImpactAlumniImpact";
import HeroImpactBanner from "../../components/impactComponents/ImpactBanners/HeroImpactBanner";
import GivingBackBanner from "../../components/impactComponents/ImpactBanners/GivingBackBanner";
import ImpactTextStack from "../../components/impactComponents/impactColorText/ImpactTextStack";

function Impact() {
  return (
    <div className="impact">
      <Helmet>
        <title>TXT Labs – Impact</title>
        <meta
          name="description"
          content="We create a greater presence of Black and Brown professionals in top tech companies."
        />
        <link rel="canonical" href="https://txtlabs.io/impact" />
      </Helmet>
      <div>
        <HeroImpactBanner />
      </div>{" "}
      <div>
        <ImpactAlumniImpact />
      </div>
      <div>
        <GivingBackBanner />
      </div>
      <div className="impactbgv">
        <HomeVideo bgvideo={vid} />
      </div>
      <div>
        <ImpactImages />
      </div>
      <div>
        <ImpactTextStack />
      </div>
    </div>
  );
}

export default Impact;
